<template>
  <router-link
    v-if="computedNextRouteProperties.visibility"
    :to="computedNextRouteProperties.path"
    :class="[
      computedNextRouteProperties.EnablePossible,
      'justify-center flex fixed md:static z-10 md:z-0 right-0',
    ]"
    style="bottom: 0em"
  >
    <!--Layout for mobile version -->
    <div
      :class="[
        theme.addToCart.border,
        computedNextRouteProperties.labelPosition,
        'block md:hidden m-4 p-2 flex shadow-lg h-12 w-54 items-center justify-center rounded-2large',
        theme.body.textColor,
        computedNextRouteProperties.EnablePossible
          ? theme.floatingCartInfoButton.unabledButtonBrackgroundColor
          : theme.addToCart.backgroundColor,
      ]"
    >
      <div
        v-if="
          this.$route.name === 'Category' ||
          this.$route.name === 'CategoryCategory' ||
          this.$route.name === 'CategoryCategory'
        "
        :class="['w-full flex text-' + theme.body.primaryLoaderColor]"
      >
        {{ computedNextRouteProperties.label }} ({{ cartItems.length }})
      </div>
      <div
        v-else
        :class="['w-full flex text-' + theme.body.primaryLoaderColor]"
      >
        {{ computedNextRouteProperties.label }}
      </div>
      <div :class="[theme.addToCart.title, 'border-l-1']">
        <div>
          <img
            class="fill-current h-6 w-6"
            :src="
              require('../assets/images/icons/' + currentBottomIcon + '.svg')
            "
            alt="Logo"
          />
        </div>
      </div>
    </div>
    <!-- Layout for normal screens -->
    <!--     Object.keys(this.cartItems).length == 0?'pointer-events-none '+ theme.addToCart.notSelectedBackgroundColor:theme.addToCart.selectedBackgroundColor
 -->

    <div class="hidden md:block">
      <div
        :class="[
          'flex rounded p-2 rounded-large items-center shadow-lg transition duration-500 hover:shadow-xl',
          theme.addToCart.backgroundColor,
        ]"
      >
        <div
          v-if="
            this.$route.name === 'Category' ||
            this.$route.name === 'CategoryCategory' ||
            this.$route.name === 'CategoryCategory'
          "
          :class="['w-full flex text-' + theme.body.primaryLoaderColor]"
        >
          {{ computedNextRouteProperties.label }} ({{ cartItems.length }})
        </div>
        <div
          v-else
          :class="['w-full flex text-' + theme.body.primaryLoaderColor]"
        >
          {{ computedNextRouteProperties.label }}
        </div>

        <div :class="[theme.addToCart.title]">
          <div>
            <img
              class="fill-current h-6 w-6"
              :src="
                require('../assets/images/icons/' + currentBottomIcon + '.svg')
              "
              alt="Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters(["menuHash", "orderStatus", "language", "menu", "theme","calculatedDistanceHomeDelivery"]),
    ...mapGetters("Cart", ["cartItems", "cartValue", "totalPriceValue","distance","homeDelivery"]),
    ...mapGetters("Cart", [
      "tableId",
      "selectedTimeSlot",
      "customer",
      "processBarCurrentItem",
      "currentBottomIcon",
      "totalPriceValueWithCostsValue",
      "tipAmount",
    ]),
    currentBottomIcon: {
      get() {
        return this.$store.getters["currentBottomIcon"];
      },
    },
    computedNextRouteProperties() {
      
      path = "";
      label = "";
      if (this.cartItems.length === 0) {
        path = `/${this.menuHash}`;
        label = lang["add_something_to_cart"][this.language];
        this.$store.commit("updateIsCartViewShown", false);
        if (this.theme.body.textColor === "text-white") {
          this.$store.commit("updateCurrentBottomIcon", "menu");
        } else {
          this.$store.commit("updateCurrentBottomIcon", "menuBlack");
        }

        return {
          visibility: false,
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: true,
          showItems: false,
        };
      }
      if (
        this.$route.name === "Category" ||
        this.$route.name === "CategoryCategory"
      ) {
        this.$store.commit("updateIsCartViewShown", true);
      } else {
        this.$store.commit("updateIsCartViewShown", false);
      }

      let homeRouteNames = [
        "Home",
        "Category",
        "SubItem",
        "SubCategory",
        "Payment",
        "CategoryCategory",
      ];
      let path = "";
      let label = "";
      let pointer = "";
      
      if (homeRouteNames.includes(this.$route.name)) {
        let pointer = "";
        this.$store.commit("updateOrderStatus","New");
        path = `/${this.menuHash}/${localStorage.getItem('stickerId')}/order-details`;
        label = this.lang["order_details"][this.language];
        if (this.theme.body.textColor === "text-white") {
          this.$store.commit("updateCurrentBottomIcon", "bag");
        } else {
          this.$store.commit("updateCurrentBottomIcon", "bagBlack");
        }
        this.$store.commit("updateProcessBarCurrentItem", 1);
        if (["New"].includes(this.orderStatus)) {
          path = `/${this.menuHash}/${localStorage.getItem('stickerId')}/cart`;
        }
        if (this.$route.name === "Payment") {
          this.$store.commit("updateProcessBarCurrentItem", 7);
          label = this.lang["go_back_to_your_order"][this.language];
        }
        if (Object.keys(this.cartItems).length != 0) {
          pointer = "";
        } else {
          pointer = "pointer-events-none";
        }
        return {
          visibility: true,
          EnablePossible: pointer,
          path: path,
          label: label,
          labelPosition: "justify-between",
          showIcon: false,
          showItems: true,
        };
      }
      if (this.$route.name == "payment") {
        this.$store.commit("updateProcessBarCurrentItem", 7);
      }
      if (this.$route.name == "Cart") {
        if (
          Object.keys(this.cartItems).length != 0 &&
          this.totalPriceValueWithCostsValue >= this.menu.min_spent_amount
        ) {
          pointer = "";
        } else {
          pointer = "pointer-events-none";
        }
        this.$store.commit("updateProcessBarCurrentItem", 1);
        if (
          this.menu.timeslots_mode == "general" ||
          this.menu.timeslots_mode == "individual"
        ) {
          if (this.menu.pos_mode == "take-out") {
            label = lang["select_time_slot"][this.language];
            path = `/${this.menuHash}/cart/time-slot-selection`;
            if (this.theme.body.textColor === "text-white") {
              this.$store.commit("updateCurrentBottomIcon", "clock");
            } else {
              this.$store.commit("updateCurrentBottomIcon", "clockBlack");
            }
          } else {      
            if (localStorage.getItem('stickerId')==0) {
              path = `/${this.menuHash}/cart/table-selection`;
              label = lang["select_table"][this.language];
              if (this.theme.body.textColor === "text-white") {
                this.$store.commit("updateCurrentBottomIcon", "table");
              } else {
                this.$store.commit("updateCurrentBottomIcon", "tableBlack");
              }
            } else {
              path = `/${this.menuHash}/cart/user-details`;
              label = lang["leave_contact_details"][this.language];
              this.$store.commit("updateProcessBarCurrentItem", 5);
              if (this.theme.body.textColor === "text-white") {
                this.$store.commit("updateCurrentBottomIcon", "contactDetails");
              } else {
                this.$store.commit(
                  "updateCurrentBottomIcon",
                  "contactDetailsBlack"
                );
              }
            }
          }
        } else {
          if (this.menu.pos_mode == "take-out") {
            path = `/${this.menuHash}/cart/user-details`;
            label = lang["leave_contact_details"][this.language];
            if (this.theme.body.textColor === "text-white") {
              this.$store.commit("updateCurrentBottomIcon", "contactDetails");
            } else {
              this.$store.commit(
                "updateCurrentBottomIcon",
                "contactDetailsBlack"
              );
            }
          } else {
            if (localStorage.getItem('stickerId')==0) {
              path = `/${this.menuHash}/cart/table-selection`;
              label = lang["select_table"][this.language];
              if (this.theme.body.textColor === "text-white") {
                this.$store.commit("updateCurrentBottomIcon", "table");
              } else {
                this.$store.commit("updateCurrentBottomIcon", "tableBlack");
              }
            } else {
              if (this.menu.customer_details_disabled == false) {
                path = `/${this.menuHash}/cart/user-details`;
                label = lang["leave_contact_details"][this.language];
                this.$store.commit("updateProcessBarCurrentItem", 3);
                if (this.theme.body.textColor === "text-white") {
                  this.$store.commit(
                    "updateCurrentBottomIcon",
                    "contactDetails"
                  );
                } else {
                  this.$store.commit(
                    "updateCurrentBottomIcon",
                    "contactDetailsBlack"
                  );
                }
              } else 
              {
                path = `/${this.menuHash}/cart/payment`;
                label = lang["continue_to_payment"][this.language];
              }
            }
          }
        }
        return {
          visibility: true,
          EnablePossible: pointer,
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: true,
          showItems: false,
        };
      }
      if (homeRouteNames.includes(this.$route.name)) {
        path = `/${this.menuHash}/cart/user-details`;
        label = lang["proceed_to_checkout"][this.language];

        if (
          this.menu.pos_mode == "take-out" &&
          (this.menu.timeslots_mode == "general" ||
            this.menu.timeslots_mode == "individual")
        ) {
          label = lang["select_time_slot"][this.language];
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "clock");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "clockBlack");
          }
          path = `/${this.menuHash}/cart/time-slot-selection`;
        }

        if (this.menu.customer_details_disabled == false) {
          path = `/${this.menuHash}/cart/table-selection`;
          label = lang["select_table"][this.language];
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "table");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "tableBlack");
          }
          this.$store.commit("updateProcessBarCurrentItem", 3);

          if (localStorage.getItem('stickerId')==0) {
            path = `/${this.menuHash}/cart/payment`;
            label = lang["continue_to_payment"][this.language];
            this.$store.commit("updateProcessBarCurrentItem", 5);
            if (this.theme.body.textColor === "text-white") {
              this.$store.commit("updateCurrentBottomIcon", "payment");
            } else {
              this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
            }
          }
        }
        return {
          visibility: true,
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: true,
          showItems: false,
        };

      }
      if (this.$route.name == "UserDetails") {
        if (this.customer.phone != "" || this.$cookies.isKey("p")){
          pointer = "";
          if(this.menu.enable_delivery&&this.homeDelivery) 
          {
            if(this.calculatedDistanceHomeDelivery>this.menu.max_delivery_distance || this.calculatedDistanceHomeDelivery == 0)
            {
              pointer = "pointer-events-none";
            }
          }
        } else {
          pointer = "pointer-events-none";
        }

        path = `/${this.menuHash}/cart/table-selection`;
        label = lang["select_table"][this.language];
        if (this.theme.body.textColor === "text-white") {
          this.$store.commit("updateCurrentBottomIcon", "table");
        } else {
          this.$store.commit("updateCurrentBottomIcon", "tableBlack");
        }

        this.$store.commit("updateProcessBarCurrentItem", 3);

        if (this.menu.pos_mode == "take-out" || this.tableId !=0) {
          path = `/${this.menuHash}/cart/payment`;
          label = lang["continue_to_payment"][this.language];
          this.$store.commit("updateProcessBarCurrentItem", 5);
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "payment");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
          }
        }

        return {
          visibility:
            this.customer.phone ||
            this.selectedTimeSlot == "" ||
            this.$cookies.isKey("p"),
          path: path,
          EnablePossible: pointer,
          label: label,
          labelPosition: "justify-center",
          showIcon: false,
          showItems: false,
        };
      }

      if (this.$route.name == "TimeSlotSelection") {
        path = "";
        label = "";
        let pointer = "";
        if (this.menu.customer_details_disabled == false) {
          path = `/${this.menuHash}/cart/user-details`;
          label = lang["leave_contact_details"][this.language];
          this.$store.commit("updateProcessBarCurrentItem", 3);
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "contactDetails");
          } else {
            this.$store.commit(
              "updateCurrentBottomIcon",
              "contactDetailsBlack"
            );
          }
        } else {
          path = `/${this.menuHash}/cart/payment`;
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "payment");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
          }
          label = lang["continue_to_payment"][this.language];
          this.$store.commit("updateProcessBarCurrentItem", 3);
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "payment");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
          }
        }
        if (this.selectedTimeSlot != "") {
          pointer = "";
        } else {
          pointer = "pointer-events-none";
        }

        return {
          visibility: true,
          EnablePossible: pointer,
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: false,
          showItems: false,
        };
      }

      if (this.$route.name == "TableSelection") {
        pointer = "";
        path = `/${this.menuHash}/cart/payment`;
        if (this.menu.pos_mode == "table" && localStorage.getItem('stickerId')==0) {
          path = this.$route.path;
        }
        if (this.theme.body.textColor === "text-white") {
          this.$store.commit("updateCurrentBottomIcon", "payment");
        } else {
          this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
        }
        this.$store.commit("updateProcessBarCurrentItem", 5);
        if (this.menu.customer_details_disabled == false) {
          path = `/${this.menuHash}/cart/user-details`;
          label = lang["leave_contact_details"][this.language];
          this.$store.commit("updateProcessBarCurrentItem", 3);
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "contactDetails");
          } else {
            this.$store.commit(
              "updateCurrentBottomIcon",
              "contactDetailsBlack"
            );
          }
        } else {
          path = `/${this.menuHash}/cart/payment`;
          if (this.theme.body.textColor === "text-white") {
            this.$store.commit("updateCurrentBottomIcon", "payment");
          } else {
            this.$store.commit("updateCurrentBottomIcon", "paymentBlack");
          }
          label = lang["continue_to_payment"][this.language];
          this.$store.commit("updateProcessBarCurrentItem", 3);
        }

        if (localStorage.getItem('stickerId')==0) {
          pointer = "";
        } else {
          pointer = "pointer-events-none";
        }

        return {
          visibility: true,
          EnablePossible: pointer,
          path: path,
          label: label,
          labelPosition: "justify-center",
          showIcon: false,
          showItems: false,
        };
      }
      if (this.$route.name == "Payment") {
        this.$store.commit("updateProcessBarCurrentItem", 7);
      }
      return {
        visibility: false,
      };
    },
  },
};
</script>